$(document).ready(function () {
   
    $(".search__btn").click(function () {
        let lang = '/' + $("#lang").val();
        let searchtext = $(".search__input").val();
        let autoRedirect = $(".autoRedirect").val();
        if (autoRedirect == "true") {
            let loc = lang + "/product/" + searchtext;
            $("#search-form").attr('action', loc);
        }
        else {
            let loc = lang + "/search?q=" + searchtext + "&activetab=%23products";
            $("#search-form").attr('action', loc);
        }       
    });
});